import { QueryClientProvider } from "@tanstack/react-query";
import { HashRouter as ReactRouter, Routes, Route } from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";
import { IsometricCityPage } from "./pages/IsometricCityPage";
import gsap from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function Router() {
  gsap.registerPlugin(DrawSVGPlugin);
  gsap.registerPlugin(ScrollTrigger);
  return (
    <QueryClientProvider client={queryClient}>
      <ReactRouter>
        <Routes>
          {/* 메인 페이지 - 인트로 + 도시 통합 */}
          <Route element={<IsometricCityPage />} path="/" />
          <Route element={<IsometricCityPage />} path="/city" />
        </Routes>
      </ReactRouter>
      {/* // <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}
